import { findParent } from "UI/UI.ElementarControls/Utils/CustomElementUtils";
import { Event, EventCallback } from "../../../../Global/Base/Events";
import { TimerUtils } from "../../../../Global/Base/Utils/TimerUtils";
import { MenuType } from "../../../UI.Controls/Actions/MenuType";
import { GenericControl } from "../Controls/Control";
import { GenericPage, GenericPageParams } from "../Controls/GenericPage";
import { UIManager } from "../UIManager";
import { DesktopToolbarButton } from "../XGControls/Actions/ToolbarButton";
import { ToolbarGroup } from "./ToolbarGroup";
import { ToolbarGroups } from "./ToolbarGroups";

/**
 * Parametry konstruktoru tridy {@link ToolbarPage}.
 */
export type ToolbarPageParams = GenericPageParams & {
    ctrlID: string;
    priority: number;
};

/**Trida pro zalozku v menu
     * http://sharepoint/vyroba/Dokumentace/Toolbar%20MW%20-%20programator.aspx
     */
export class ToolbarPage extends GenericPage {
    //#region Fields
    public visibilityChange: Event<ToolbarPage, boolean> = new Event<ToolbarPage, boolean>();
    public ctrlID: string;

    private _groups: ToolbarGroups;
    //poradi zalozky v toolbaru
    private _priority: number;
    private _color: string;
    private _oldGroupsVisibility = false;
    private _windowResizedListener: EventCallback<any, any>;
    //#endregion Fields

    //#region Properties
    public get color(): string {
        return this._color;
    }

    public set color(value: string) {
        if (this._color && this._color.length > 0)
            this.header.element.classList.remove(this._color);
        this._color = value;
        this.header.element.classList.add(value);
        //this.Header.Element.style.color = value;
        //this.Header.Element.style.boxShadow = "0px 3px 0 " + value+" inset";
    }

    public get priority(): number {
        return this._priority;
    }

    public set groups(val: ToolbarGroups) {
        this._groups = val;
        this._updateVisibility();
        this._groups.visibilityChange.add((_sender, e) => {
            if (e != this._oldGroupsVisibility) {
                this._oldGroupsVisibility = e;

                TimerUtils.waitOrCancel(`toolbarPageVisibilityChange${this.ctrlID}`, //`
                    () => {
                        this._updateVisibility();
                    }, 300);
            }
        });
    }

    public get groups(): ToolbarGroups {
        return this._groups;
    }

    public override get selected(): boolean {
        return this._selected;
    }

    public override set selected(value: boolean) {
        this._selected = value;
        if (!value)
            this.element.classList.remove("active");
        else {
            this.element.classList.add("active");
            findParent(this.element, ".Pages").querySelector(".tabPageContainer").className = `tabPageContainer ${this.color ? this.color : ""}`;
            this.groups.throttledResizeGroups();
        }
    }
    //#endregion

    //#region Constructors

    constructor({ element, header, originalRightsDefinition, ctrlID, priority }: ToolbarPageParams) {
        super({ element, header, originalRightsDefinition });
        this.groups = new ToolbarGroups({ element, originalRightsDefinition });
        this.ctrlID = ctrlID;
        this._priority = priority;
        this.element.setAttribute("data-ctrlid", ctrlID);
        let resicnt: number | undefined = undefined;

        this._windowResizedListener = () => {
            if (resicnt)
                clearTimeout(resicnt);

            resicnt = self.setTimeout(() => {
                if (this.selected) {
                    this.groups.throttledResizeGroups();
                }
                resicnt = undefined;
            },
            300);
        };
        UIManager.instance.windowResized.add(this._windowResizedListener);
    }
    //#endregion Constructors

    //#region Methods

    /**Vytvori defaultni skupinu*/
    public createDefaultGroups(): void {
        this.groups = new ToolbarGroups({ element: this.element, originalRightsDefinition: this.originalRightsDefinition });

        this.groups.createDefaultGroups();
    }

    private _updateVisibility(): void {
        if (this._visible && this.groups.visible) {
            this.element.style.display = "";
            this.header.visible = true;
            this.visibilityChange.trigger(this, true);
        } else {
            this.header.visible = false;
            this.element.style.display = "none";
            this.visibilityChange.trigger(this, false);
        }
    }

    public override hide(): void {
        this._visible = false;
        this._updateVisibility();
    }

    public override show(): void {
        this._visible = true;
        this._updateVisibility();
    }

    public override get isVisible(): boolean {
        //return this.Header.Element.style.display != "none";
        return this._visible && this.groups.visible;
    }

    //todo: MV nutno doupravit tak, aby to tady naslo vhodnou grupu a do ni to vlozilo
    public addAction(button: DesktopToolbarButton): void {
        this.element.appendChild(button.element);
    }

    public addOrFindGroup(locKey: string, toMenu: MenuType, ctrlID: string, priority?: number): ToolbarGroup {
        return this.groups.addOrFindGroup(locKey, toMenu, ctrlID, priority);
    }

    //async
    //public FindMasterNode(ctrlID: string): Promise<Control[]>[] {
    //    return this.Groups.FindMasterNode(ctrlID);
    //}

    /**najde spravny masternode*/
    public findMasterNode(ctrlID: string): GenericControl[] {
        return this.groups.findMasterNode(ctrlID);
    }

    public override dispose(): void {
        UIManager.instance.windowResized.remove(this._windowResizedListener);
        super.dispose();
    }
    //#endregion Methods
}
